import { Flex, Spinner } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { StoresInventoryStatus } from '../../../../bff-api/stores/model';
import { isAvailableStatus } from '../../../../bff-api/utils/store-utils';
import { usePDP } from '../../../../contexts/pdp/usePDP';
import { useBopisStore } from '../../../../hooks/useBopisStore';
import { Text } from '../../../../ui-components';

interface Props {
    id: string;
    onClickLocation: () => void;
}

export const BopisBox: React.FC<Props> = ({ id, onClickLocation }: Props) => {
    const {
        inventoryStore: {
            currentInventory: { status, availableToSell },
        },
        isLoadingBopisInventory,
    } = usePDP();
    const { data: store } = useBopisStore();

    const isAvailable = isAvailableStatus(status);

    return (
        <Flex
            data-testid={id}
            direction="column"
            gap={2}
            padding={3}
            borderRadius={4}
            background="slt-grey.100"
            width="100%"
        >
            {isLoadingBopisInventory ? (
                <Spinner data-testid={`${id}-loading`} alignSelf="center" />
            ) : (
                <Flex data-testid={`${id}-location`} direction="column" gap={2}>
                    <Flex
                        direction={!store?.id || isAvailable ? 'row' : 'column'}
                        gap={2}
                        wrap="wrap"
                    >
                        <Text id={`${id}-location-label`} style="bold">
                            {!store?.id || isAvailable ? (
                                <FormattedMessage
                                    id="store.pick.up.at"
                                    defaultMessage="Pick up at {store}"
                                    values={{ store: store?.name ?? '' }}
                                />
                            ) : (
                                <FormattedMessage
                                    id="store.pick.up.not.available.in"
                                    defaultMessage="Item is not available in {store}"
                                    values={{ store: store?.name ?? '' }}
                                />
                            )}
                        </Text>

                        <Text id={`${id}-location-button`} type="link" onClick={onClickLocation}>
                            {store?.id ? (
                                <FormattedMessage
                                    id="store.pick.up.change.location"
                                    defaultMessage="Change Location"
                                />
                            ) : (
                                <FormattedMessage
                                    id="store.pick.up.choose.location"
                                    defaultMessage="Choose Location"
                                />
                            )}
                        </Text>
                    </Flex>

                    {store?.id && availableToSell <= 0 ? (
                        <Text
                            id={`${id}-location-helper-label`}
                            size="small"
                            onClick={onClickLocation}
                        >
                            {status ===
                            StoresInventoryStatus.PRODUCT_ONLY_AVAILABLE_IN_ANOTHER_VARIANT ? (
                                <FormattedMessage
                                    id="store.pick.up.different.color.size.store"
                                    defaultMessage="Please select a different color/size or store."
                                />
                            ) : (
                                <FormattedMessage
                                    id="store.pick.up.different.store"
                                    defaultMessage="Please select a different store."
                                />
                            )}
                        </Text>
                    ) : null}
                </Flex>
            )}
        </Flex>
    );
};
